import React, {useCallback, useEffect, useRef, useState} from 'react';
import {useParams} from 'react-router-dom';
import AppHeader from '../components/AppHeader.js';
import Search from '../components/Search.js';
import PaymentList from '../components/PaymentList.js';

export default function Payment({usrInfo, timerCnt}) {
	const {directSearch} = useParams();
	const [loading, setLoading] = useState(false);
	const [searchValue, setSearchValue] = useState(directSearch || '');
	const [prevDirectSearch, setPrevDirectSearch] = useState(directSearch);
	const listRef = useRef(null);

	// Reakce na jméno v URL (/payment/Jméno) – změna parametru přepne vyhledávání
	// i když už v sekci jsem. Hledání se srovná hned při renderu, ať se seznam
	// nenačítá dvakrát (nejdřív se starou hodnotou).
	if (directSearch !== prevDirectSearch) {
		setPrevDirectSearch(directSearch);
		setSearchValue(directSearch || '');
	}

	useEffect(() => {
		if (typeof directSearch !== 'undefined' && directSearch !== '') {
			window.history.pushState({}, document.title, '/payment');
		}
	}, [directSearch]);

	const handleLoadingChange = useCallback((isLoading) => {
		setLoading(isLoading);
	}, []);

	return (
		<>
			<div className="page_main">
				<AppHeader usrInfo={usrInfo} timerCnt={timerCnt} loading={loading} />
				<Search showSearch searchValue={searchValue} onChangeSearch={(e) => setSearchValue(e)} showNew={usrInfo.sysAdmin === 1 ? true : false} handleNew={() => listRef.current?.openNew()} />

				<div className={`page payment-page${usrInfo.sysAdmin === 1 || usrInfo.manager === 1 || usrInfo.instructor === 1 ? ' more' : ''}`}>
					<PaymentList ref={listRef} usrInfo={usrInfo} searchValue={searchValue} onChangeSearch={setSearchValue} onLoadingChange={handleLoadingChange} />
				</div>
			</div>
		</>
	);
}
